export enum AccessPackageFormMode {
    Add = "Add",
    Update = "Update",
    Migrate = "Migrate"
}
